import React from 'react';
import { makeStyles } from '@mui/styles';
import { AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import { CodeHighlighter } from '../index';
import { AdminProgressBar } from '../../../../components';

const useStyles = makeStyles((theme) => ({
  pre: {
    whiteSpace: 'pre-wrap',
  },
  childAccordion: {
    display: 'block',
  },
  headingPost: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    color: theme.palette.success.main,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const UserLogout = () => {
  const classes = useStyles();
  return (
    <AccordionDetails className={classes.childAccordion}>
      <Typography>
        <Grid
          container
          item
          xs={12}
          spacing={2}
          justifyContent={'space-between'}
        >
          <Grid
            item
            xs={2}
          >
            <h3>Example Response</h3>
          </Grid>
          <Grid
            item
            xs={10}
          >
            <CodeHighlighter
              code={`{}
  `}
            />
          </Grid>
          <Grid
            item
            xs={2}
          >
            <h3>Error Response</h3>
          </Grid>
          <Grid
            item
            xs={10}
          >
            <CodeHighlighter
              code={`{}
  `}
            />
          </Grid>
        </Grid>
      </Typography>
    </AccordionDetails>
  );
};
const Wrapper = () => {
  return (
    <React.Suspense fallback={<AdminProgressBar />}>
      <UserLogout />
    </React.Suspense>
  );
};
export default Wrapper;
